export const EnHeader = {
  "header": {
    "loggedRole": "Role: {role}",
    "loggedWith": "Logged in as {name}",
    "usedProject": "Project",
    "usedRoleView": "View"
  },
}